import {
    GET_INT_OMS_PENDING_SUMMARY_REPORT_REQUEST,
    GET_INT_OMS_PENDING_SUMMARY_REPORT_SUCCESS,
    GET_INT_OMS_PENDING_SUMMARY_REPORT_ERROR
} from "./types.js";
import { BASEURL } from "../../constant/config.js"
import axios from "axios";
import moment from "moment";

export const getOMSIntPendingSummaryReport = (token, values) => (dispatch) => {
    let cleanedVal =
        typeof values.customer === 'string'
            ? values.customer
                .replace(/\t/g, '')       // remove tab characters
                .replace(/'/g, "''")      // escape single quotes
                .trim()                   // remove extra spaces
            : null;
    let cleanedVal1 = values.billing_addressee === undefined ? null : values.billing_addressee.includes("'") ? values.billing_addressee.replace(/'/g, "''") : values.billing_addressee;
    dispatch({ type: GET_INT_OMS_PENDING_SUMMARY_REPORT_REQUEST });
    const newData = {
        // customer_cat_id: values.cutomer_category === "All" ? null : values.cutomer_category,
        date_from: moment(values.from_date).format("YYYY-MM-DD"),
        date_to: moment(values.to_date).format("YYYY-MM-DD"),
        order_header_no: values.order_no === undefined || values.order_no === "" ? null : values.order_no,
        reference_no: values.po_no === undefined || values.po_no === "" ? null : values.po_no,
        customer: (cleanedVal === undefined || cleanedVal === "" || cleanedVal === "All") ? null : cleanedVal,
        bill_addressee: cleanedVal1 === undefined || cleanedVal1 === "" ? null : cleanedVal1,
        salesperson: values.salesContract === "All" ? null : values.salesContract,
        region: values.region === "All" ? null : values.region,
        // gender: values.gender === "All" ? null : values.gender,
        payment_term_name: values.payment_term === "All" ? null : values.payment_term,
        // store_id: values.store === undefined || values.store === "" ? null : values.store,
        // company_id: values.subsidary === undefined ? 2 : 2,
        // source_type: values.source === undefined || values.source === "" ? null : values.source,
        sku: values.sku === undefined || values.sku === "" ? null : values.sku,
        // status: values.status === undefined || values.status === "" ? null : values.status,
        // location_id: values.location === undefined || values.location === "All" ? null : values.location,
        style: values.style === undefined || values.style === "All" ? null : values.style,
        wash: values.wash === undefined || values.wash === "All" ? null : values.wash,
        city: values.city === undefined || values.city === "All" ? null : values.city,
        state: values.state === undefined || values.state === "All" ? null : values.state,
        country: values.country === undefined || values.country === "All" ? null : values.country,
        zip: values.zip === undefined || values.zip === "" ? null : values.zip,
        email: values.email === undefined || values.email === "" ? null : values.email,
        freightterm: values.freight === undefined || values.freight === "All" ? null : values.freight,
        shipper: values.shipper === undefined || values.shipper === "" ? null : values.shipper,
    };

    return axios({
        method: "POST",
        url: `${BASEURL}getAll/OMSPendingSummaryInternational`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: newData,
    })
        .then((response) => {
            return dispatch({
                type: GET_INT_OMS_PENDING_SUMMARY_REPORT_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            dispatch({
                type: GET_INT_OMS_PENDING_SUMMARY_REPORT_ERROR,
                payload: [],
            });

        });
};
